import { baseRestApi } from "api/rest/baseRestApi";

import { Shipper } from "./types";

type ResponseType = { data: { shipper: Shipper } };

module.hot?.accept();

export const getShipperApi = baseRestApi.enhanceEndpoints({ addTagTypes: ["SHIPPERS"] }).injectEndpoints({
  overrideExisting: module.hot?.status() === "apply",
  endpoints: (builder) => ({
    getShipper: builder.query<ResponseType, void>({
      query: () => ({
        method: "GET",
        url: `shipper/shippers`,
      }),
      providesTags: ["SHIPPERS"],
    }),
  }),
});

export const { useGetShipperQuery } = getShipperApi;

export default getShipperApi;
